import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { HttpService } from 'tms-lib';
import { TmsWebBaseImportService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ImportSupplierProductInSupplerService extends TmsWebBaseImportService {
  constructor(protected httpService: HttpService) {
    super('ImportSupplierProductInSupplier', 'Supplier Products', httpService);
  }

  exportSupplierProducts(supplierId: string): Observable<any> {
    return this.httpService
      .getForText(`${this.apiUrl}/ExportSupplierProducts?supplierId=${supplierId}`)
      .pipe(tap((data: string) => this.downloadExportFile(data, 'SupplierProducts')));
  }

  importSupplierProducts(file: any, id: string): Observable<any> {
    const formData = this.getFormData(file);
    return this.httpService.postForText(`${this.apiUrl}/ImportSupplierProducts/${id}`, formData);
  }
}
